/* Tack & Tweed: Events (v2). Fallback date sort (in case the page was cached), empty state, drop-off block,
   sign-up consent gate and the photo viewer. No tracking, no network calls. Safe to load more than once. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, k) { if (el.dataset[k]) return false; el.dataset[k] = '1'; return true; };

  function today(tz) {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  }

  /* An event is "coming up" through the day it ends and moves to Past from the next day (store time zone). */
  function sortEvents() {
    var up = document.querySelector('[data-tt-events="upcoming"]'), past = document.querySelector('[data-tt-events="past"]');
    var any = up || past; if (!any) return;
    var now = today(any.dataset.tz || 'America/New_York');
    var over = function (el) { return (el.dataset.endDay || '') < now; };
    [[up, 1], [past, -1]].forEach(function (p) {
      if (!p[0]) return;
      var list = p[0].querySelector('[data-tt-list]'), items = $$('[data-tt-event]', list);
      items.forEach(function (el) { el.hidden = p[1] === 1 ? over(el) : !over(el); });
      items.sort(function (a, b) { return a.dataset.start < b.dataset.start ? -p[1] : a.dataset.start > b.dataset.start ? p[1] : 0; })
        .forEach(function (el) { list.appendChild(el); });
    });
    var next = up ? $$('[data-tt-event]', up).filter(function (el) { return !el.hidden; })[0] : null;
    if (up) { var empty = up.querySelector('[data-tt-empty]'); if (empty) empty.hidden = !!next; }
    $$('[data-tt-bring]').forEach(function (b) { b.hidden = !!next && next.dataset.consign === 'false'; });
  }

  function emptyCta() {
    $$('[data-tt-empty-cta]').forEach(function (a) {
      if (!once(a, 'ttReady')) return;
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').split('#')[1], t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var f = t.querySelector('input[type=email]'); if (f) f.focus({ preventScroll: true });
      });
    });
  }

  /* Sign-up: the unticked consent box must be ticked; the email must look valid. Then Shopify's customer form submits normally. */
  function signup() {
    $$('form[data-tt-signup]').forEach(function (form) {
      if (!once(form, 'ttReady')) return;
      var email = form.querySelector('[data-su-email]'), consent = form.querySelector('[data-su-consent]');
      if (!email || !consent) return;
      var eErr = document.getElementById(email.getAttribute('aria-describedby')), cErr = document.getElementById(consent.getAttribute('aria-describedby'));
      form.noValidate = true;
      form.addEventListener('submit', function (e) {
        var v = email.value.trim(), ok = v !== '' && email.checkValidity();
        eErr.hidden = ok; eErr.textContent = ok ? '' : (v === '' ? 'Please enter your email.' : 'Please enter a valid email address.');
        if (ok) email.removeAttribute('aria-invalid'); else email.setAttribute('aria-invalid', 'true');
        cErr.hidden = consent.checked; cErr.textContent = consent.checked ? '' : 'Please tick the box to sign up.';
        if (consent.checked) consent.removeAttribute('aria-invalid'); else consent.setAttribute('aria-invalid', 'true');
        if (!ok) { e.preventDefault(); email.focus(); return; }
        if (!consent.checked) { e.preventDefault(); consent.focus(); }
      });
      consent.addEventListener('change', function () { if (consent.checked) { cErr.hidden = true; consent.removeAttribute('aria-invalid'); } });
    });
    var done = document.querySelector('[data-su-success]');
    if (done && /[?&]customer_posted=true(&|$)/.test(location.search)) { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }
  }

  function lightbox() {
    var dlg = document.querySelector('[data-tt-lightbox]'); if (!dlg || !once(dlg, 'ttReady')) return;
    var img = dlg.querySelector('[data-lb-img]'), cap = dlg.querySelector('[data-lb-cap]');
    var prev = dlg.querySelector('[data-lb-prev]'), next = dlg.querySelector('[data-lb-next]'), set = [], idx = 0, opener = null;
    function show(i) {
      idx = (i + set.length) % set.length;
      var b = set[idx], t = b.querySelector('img');
      img.removeAttribute('width'); img.removeAttribute('height');
      img.src = b.dataset.full || b.dataset.lightboxSingle;
      img.alt = t ? t.alt : (b.dataset.caption || '');
      cap.textContent = (b.dataset.caption || '') + (set.length > 1 ? ' (' + (idx + 1) + ' of ' + set.length + ')' : '');
      prev.hidden = next.hidden = set.length < 2;
    }
    function open(group, i, btn) {
      set = group; opener = btn; show(i);
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      dlg.querySelector('[data-lb-close]').focus();
    }
    function close() { if (dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); } }
    dlg.addEventListener('close', function () { if (opener) opener.focus(); });
    $$('[data-gallery]').forEach(function (g) {
      var btns = $$('button[data-full]', g);
      btns.forEach(function (b, i) {
        var t = b.querySelector('img');
        b.setAttribute('aria-label', 'Open photo: ' + (t ? t.alt : b.dataset.caption));
        b.addEventListener('click', function () { open(btns, i, b); });
      });
    });
    $$('[data-lightbox-single]').forEach(function (b) { b.addEventListener('click', function () { open([b], 0, b); }); });
    prev.addEventListener('click', function () { show(idx - 1); });
    next.addEventListener('click', function () { show(idx + 1); });
    dlg.querySelector('[data-lb-close]').addEventListener('click', close);
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' && set.length > 1) { e.preventDefault(); show(idx - 1); }
      if (e.key === 'ArrowRight' && set.length > 1) { e.preventDefault(); show(idx + 1); }
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  }

  function init() { sortEvents(); emptyCta(); signup(); lightbox(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
